import {
  FIELD_MAX_LENGTHS,
  MASK_PRESETS,
  MASK_PRESET_OPTIONS,
} from '@/shared/constants';
import { Field, Switch } from '@noorden-insurtech/alba-design-system';
import { withMask } from 'use-mask-input';

type Props = {
  useIndividualDocument: boolean;
  onUseIndividualDocumentChange: (value: boolean) => void;
  documentNumber: string;
  onDocumentNumberChange: (value: string) => void;
  documentError?: string;
  documentHelperText?: string;
  name: string;
  onNameChange: (value: string) => void;
  nameError?: string;
  required?: boolean;
  disabled?: boolean;
};

export function StipulantIdentification({
  useIndividualDocument,
  onUseIndividualDocumentChange,
  documentNumber,
  onDocumentNumberChange,
  documentError,
  documentHelperText,
  name,
  onNameChange,
  nameError,
  required,
  disabled,
}: Props) {
  const documentLabel = useIndividualDocument ? 'CPF / CAEPF' : 'CNPJ';
  const documentPlaceholder = useIndividualDocument
    ? 'XXX.XXX.XXX-XX ou XXX.XXX.XXX/XXX-XX'
    : 'XX.XXX.XXX/XXXX-XX';
  const documentMask = useIndividualDocument
    ? MASK_PRESETS.cpfCaepf
    : MASK_PRESETS.cnpj;
  // CNPJ alfanumérico entra sempre em maiúsculas.
  const documentMaskOptions = useIndividualDocument
    ? undefined
    : MASK_PRESET_OPTIONS.cnpj;
  const documentMaxLength = useIndividualDocument
    ? FIELD_MAX_LENGTHS.cpfCaepf
    : FIELD_MAX_LENGTHS.cnpj;
  const nameLabel = useIndividualDocument ? 'Nome' : 'Razão Social';
  const namePlaceholder = useIndividualDocument
    ? 'Digite o nome'
    : 'Digite o nome do estipulante';

  return (
    <div className='flex flex-col gap-4'>
      <Switch.Root
        checked={useIndividualDocument}
        onCheckedChange={details =>
          onUseIndividualDocumentChange(details.checked)
        }
        disabled={disabled}
      >
        <Switch.Control>
          <Switch.Thumb />
        </Switch.Control>
        <Switch.Label>CPF / CAEPF</Switch.Label>
        <Switch.HiddenInput />
      </Switch.Root>

      <div className='grid grid-cols-1 lg:grid-cols-2 gap-10'>
        <Field.Root invalid={!!documentError}>
          <Field.Label className='text-sm font-bold text-alba-black-500'>
            {documentLabel}
            {required && <span className='text-alba-error-red-500'>*</span>}
          </Field.Label>
          <Field.Input
            key={
              useIndividualDocument ? 'stipulant-doc-cpf' : 'stipulant-doc-cnpj'
            }
            ref={withMask(documentMask, documentMaskOptions)}
            value={documentNumber}
            onChange={e => onDocumentNumberChange(e.target.value)}
            placeholder={documentPlaceholder}
            disabled={disabled}
            maxLength={documentMaxLength}
          />
          {documentError && <Field.ErrorText>{documentError}</Field.ErrorText>}
          {!documentError && documentHelperText ? (
            <Field.HelperText>{documentHelperText}</Field.HelperText>
          ) : null}
        </Field.Root>

        <Field.Root invalid={!!nameError}>
          <Field.Label className='text-sm font-bold text-alba-black-500'>
            {nameLabel}
            {required && <span className='text-alba-error-red-500'>*</span>}
          </Field.Label>
          <Field.Input
            value={name}
            onChange={e => onNameChange(e.target.value)}
            placeholder={namePlaceholder}
            disabled
          />
          {nameError && <Field.ErrorText>{nameError}</Field.ErrorText>}
        </Field.Root>
      </div>
    </div>
  );
}
